import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_32_petty_cash_voucher: any[] =   [
    {
      "componentType": "screenGroup",
      "title": "Petty cash",
      "style": {},
      "childComponents": [
        {
          "componentType": "form",
          "Name": "petty_cash_voucher",
          "TableName": "vouchers",
          "DisplayName": "vouchers",
          "Plugins": [
            {
              "type": "api",
              "module": "all"
            }
          ],
          "columnNumber": "m1 t1 w1",
          "style": {
            "padding": 10,
            "backgroundColor": "#ffffff",
            "direction": "column"
          },
          "Fields": [
            {
              "componentType": "fieldGroup",
              "Label": "Petty cash voucher details",
              "BindValue": "petty_cash_voucher_header",
              "style": {
                "direction": "column"
              },
              "childComponents": [
                {
                  "IncludeLabel": true,
                  "Label": "Voucher No.",
                  "PlaceHolder": "Will be auto generated...",
                  "IsMandatory": false,
                  "BindValue": "txt_voucher_no",
                  "Json_Attribute": "voucher_no",
                  "componentType": "textField",
                  "showInSummary": false,
                  "AutoPopulate": true,
                  "IsReadOnly": true,
                  "AutoPopulate_format": "PTY_[******]",
                  "IsVerticalView": true,
                  "inputType": "text"
                },
                {
                  "IncludeLabel": true,
                  "Label": "Voucher date",
                  "PlaceHolder": "",
                  "IsMandatory": true,
                  "BindValue": "txt_voucher_date",
                  "Json_Attribute": "voucher_date",
                  "componentType": "dateField",
                  "showInSummary": true,
                  "DefaultToday": true,
                  "IsVerticalView": true,
                  "validation": [
                    {
                      "rule": "required",
                      "message": "Voucher date is required"
                    }
                  ]
                },
                {
                  "IncludeLabel": true,
                  "Label": "Narration",
                  "PlaceHolder": "",
                  "IsMandatory": true,
                  "BindValue": "txt_narration",
                  "Json_Attribute": "narration",
                  "componentType": "textField",
                  "showInSummary": true,
                  "IsVerticalView": true,
                  "inputType": "text",
                  "validation": [
                    {
                      "rule": "required",
                      "message": "Narration is required"
                    }
                  ]
                },
                {
                  "IncludeLabel": true,
                  "Label": "Ref No.",
                  "PlaceHolder": "Ref No.",
                  "IsMandatory": false,
                  "BindValue": "txt_Ref_no",
                  "Json_Attribute": "ref_no",
                  "componentType": "textField",
                  "showInSummary": true,
                  "IsVerticalView": true,
                  "inputType": "text"
                },
                {
                  "IncludeLabel": true,
                  "Label": "Voucher type",
                  "PlaceHolder": "",
                  "IsMandatory": false,
                  "BindValue": "txt_voucher_type_",
                  "Json_Attribute": "voucher_type",
                  "componentType": "textField",
                  "showInSummary": true,
                  "Default_Value": "Petty",
                  "IsReadOnly": true,
                  "IsVerticalView": true,
                  "inputType": "text"
                },
                {
                  "IncludeLabel": true,
                  "Label": "Ref date",
                  "PlaceHolder": "",
                  "IsMandatory": true,
                  "BindValue": "txt_reference_date",
                  "Json_Attribute": "ref_date",
                  "componentType": "dateField",
                  "showInSummary": true,
                  "DefaultToday": true,
                  "IsVerticalView": true,
                  "validation": [
                    {
                      "rule": "required",
                      "message": "Ref date is required"
                    }
                  ]
                }
              ]
            },
            {
              "componentType": "subModule",
              "name": "voucher_details",
              "label": "Voucher details",
              "tableName": "voucher_details",
              "lookupName": "",
              "BindValue": "voucher_details",
              "NotAllowEmpty": true,
              "childControls": [
                {
                  "IncludeLabel": true,
                  "Label": "Jobcard No.",
                  "PlaceHolder": "",
                  "IsMandatory": false,
                  "BindValue": "job_card_id",
                  "Json_Attribute": "job_card_id",
                  "componentType": "searchableDropdown",
                  "LookupName": "voucher_jobcard",
                  "IsVerticalView": true,
                  "showInSummary": true,
                  "validation": []
                },
                {
                  "IncludeLabel": true,
                  "Label": "Debit",
                  "PlaceHolder": "",
                  "IsMandatory": true,
                  "BindValue": "drp_ledger",
                  "Json_Attribute": "to_ledger",
                  "componentType": "searchableDropdown",
                  "LookupName": "Petty_to_ledger",
                  "IsVerticalView": true,
                  "showInSummary": false,
                  "EnableEditForControl": false,
                  "validation": [
                    {
                      "rule": "required",
                      "message": "Debit is required"
                    }
                  ]
                },
                {
                  "IncludeLabel": true,
                  "Label": "Debit narration",
                  "PlaceHolder": "",
                  "IsMandatory": true,
                  "BindValue": "txt_to_narration",
                  "Json_Attribute": "to_narration",
                  "componentType": "textField",
                  "showInSummary": true,
                  "IsVerticalView": false,
                  "inputType": "text",
                  "validation": [
                    {
                      "rule": "required",
                      "message": "Debit narration is required"
                    }
                  ]
                },
                {
                  "IncludeLabel": true,
                  "Label": "Credit",
                  "PlaceHolder": "",
                  "IsMandatory": true,
                  "BindValue": "drp_from_ledger",
                  "Json_Attribute": "ledger_id",
                  "componentType": "searchableDropdown",
                  "LookupName": "Petty_ledgers",
                  "IsVerticalView": true,
                  "showInSummary": false,
                  "EnableEditForControl": false,
                  "validation": [
                    {
                      "rule": "required",
                      "message": "Credit is required"
                    }
                  ]
                },
                {
                  "IncludeLabel": true,
                  "Label": "Credit narration",
                  "PlaceHolder": "",
                  "IsMandatory": true,
                  "BindValue": "txt_remarks",
                  "Json_Attribute": "remarks",
                  "componentType": "textField",
                  "showInSummary": true,
                  "IsVerticalView": false,
                  "inputType": "text",
                  "validation": [
                    {
                      "rule": "required",
                      "message": "Credit narration is required"
                    }
                  ]
                },
                {
                  "IncludeLabel": true,
                  "Label": "Amount",
                  "PlaceHolder": "",
                  "IsMandatory": false,
                  "BindValue": "txt_amount",
                  "Json_Attribute": "amount",
                  "componentType": "textField",
                  "showInSummary": false,
                  "IsReadOnly": false,
                  "Default_Value": "0",
                  "IsVerticalView": true,
                  "inputType": "number",
                  "validation": [
                    {
                      "rule": "maxValue",
                      "value": 10000,
                      "message": "Petty Cash vouchers cannot exceed an amount of 10,000. Please enter a lower amount..!"
                    }
                  ]
                },
                {
                  "IncludeLabel": true,
                  "Label": "VAT %",
                  "PlaceHolder": "",
                  "IsMandatory": false,
                  "BindValue": "drp_vat",
                  "Json_Attribute": "vat_id",
                  "componentType": "selectDropdown",
                  "showInSummary": false,
                  "LookupName": "tax_rates",
                  "IncludeNotSet": false,
                  "IsVerticalView": true
                },
                {
                  "IncludeLabel": true,
                  "Label": "VAT Amount",
                  "PlaceHolder": "0",
                  "IsMandatory": false,
                  "BindValue": "txt_vat_amount",
                  "Json_Attribute": "vat_amount",
                  "componentType": "textField",
                  "showInSummary": false,
                  "IsReadOnly": true,
                  "ExpressionV2": "[txt_amount]*[drp_vat.taxrate]/100",
                  "Default_Value": "0",
                  "IsVerticalView": true,
                  "inputType": "number"
                },
                {
                  "IncludeLabel": true,
                  "Label": "Total",
                  "PlaceHolder": "",
                  "IsMandatory": false,
                  "BindValue": "txt_total",
                  "Json_Attribute": "",
                  "componentType": "textField",
                  "showInSummary": false,
                  "IsReadOnly": true,
                  "ExpressionV2": "[txt_amount]+[txt_vat_amount]",
                  "Default_Value": "0",
                  "IsVerticalView": true,
                  "inputType": "number"
                },
                {
                  "IncludeLabel": true,
                  "Label": "Party Name",
                  "PlaceHolder": "Select customer or vendor",
                  "IsMandatory": false,
                  "BindValue": "txt_party_name",
                  "Json_Attribute": "party_name",
                  "componentType": "searchableDropdown",
                  "LookupName": "customers_and_vendors",
                  "showInSummary": true,
                  "IsVerticalView": true,
                  "validation": [
                    {
                      "rule": "conditionalRequired",
                      "whenField": "drp_vat",
                      "whenValue": "1",
                      "message": "Party Name is required when VAT is 5%"
                    }
                  ]
                },
                {
                  "IncludeLabel": true,
                  "Label": "TRN (Tax Registration Number)",
                  "PlaceHolder": "",
                  "IsMandatory": false,
                  "BindValue": "txt_trn",
                  "Json_Attribute": "trn",
                  "componentType": "textField",
                  "showInSummary": true,
                  "IsVerticalView": true,
                  "inputType": "text",
                  "BindParent": {
                    "txt_party_name": "trn"
                  },
                  "validation": [
                    {
                      "rule": "conditionalRequired",
                      "whenField": "drp_vat",
                      "whenValue": "1",
                      "message": "TRN (Tax Registration Number) is required when VAT is 5%"
                    }
                  ]
                },
                {
                  "IncludeLabel": true,
                  "Label": "Bill / Invoice Number",
                  "PlaceHolder": "",
                  "IsMandatory": false,
                  "BindValue": "txt_bill_invoice_number",
                  "Json_Attribute": "bill_invoice_number",
                  "componentType": "textField",
                  "showInSummary": true,
                  "IsVerticalView": true,
                  "inputType": "text",
                  "validation": [
                    {
                      "rule": "conditionalRequired",
                      "whenField": "drp_vat",
                      "whenValue": "1",
                      "message": "Bill / Invoice Number is required when VAT is 5%"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "componentType": "button",
          "name": "Submit",
          "Label": "Submit",
          "BindValue": "btn_submit",
          "onPressAction": "save",
          "style": {
            "backgroundColor": "#22c55e",
            "textColor": "#FFFFFF",
            "padding": 12,
            "borderRadius": 8
          }
        }
      ]
    }
  ];
